import { Page } from '../components';
import { RateCompareForm } from '../forms';

export const RateCompare = () => <Page render={() => <RateCompareForm />} />;
